import { type Components, type Theme } from "@mui/material";

export const iconButtonTheme: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.custom.icon,
      "& svg[data-icon] *[stroke]": {
        vectorEffect: "non-scaling-stroke",
      },
      "&:hover": {
        background: theme.palette.custom.fillTertiaryHover,
      },
      "&.Mui-disabled": {
        opacity: theme.opacity.disabled,
      },
      variants: [
        {
          props: { variant: "contained", color: "primary" },
          style: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.custom.fillHover,
            },
            "&:active": {
              backgroundColor: theme.palette.custom.fillActive,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.custom.fillDisabled,
            },
          },
        },
        {
          props: { variant: "contained", color: "secondary" },
          style: {
            backgroundColor: theme.palette.custom.fillSecondary,
            color: theme.palette.text.main,
            "&:hover": {
              backgroundColor: theme.palette.custom.fillSecondaryHover,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.custom.fillDisabled,
            },
          },
        },
        {
          props: { variant: "contained", color: "error" },
          style: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.error.dark,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.custom.fillDisabled,
            },
          },
        },
        {
          props: { variant: "contained", color: "errorSecondary" },
          style: {
            backgroundColor: theme.palette.errorSecondary.main,
            color: theme.palette.errorSecondary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.errorSecondary.dark,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.custom.fillDisabled,
            },
          },
        },
        {
          props: { variant: "text", color: "primary" },
          style: {
            color: theme.palette.text.main,
            "&:hover": {
              background: theme.palette.custom.fillSecondaryHover,
            },
          },
        },
        {
          props: { variant: "text", color: "error" },
          style: {
            color: theme.palette.errorSecondary.contrastText,
            "&:hover": {
              background: theme.palette.errorSecondary.dark,
            },
          },
        },
        {
          props: { variant: "dashed" },
          style: {
            outline: `1px dashed ${theme.palette.custom.border}`,
            outlineOffset: "-1px",
            background: theme.palette.custom.fillNeutral,
            color: theme.palette.custom.icon,
            "&:hover": {
              outlineColor: theme.palette.custom.borderHover,
              background: theme.palette.custom.fillNeutralHover,
            },
            "&:active": {
              outlineColor: theme.palette.custom.borderActive,
              background: theme.palette.custom.fillNeutralActive,
            },
            "&.Mui-disabled": {
              outlineColor: theme.palette.custom.borderDisabled,
              background: theme.palette.custom.fillNeutralDisabled,
              color: theme.palette.custom.iconDisabled,
            },
          },
        },
        {
          props: { size: "xsmall" },
          style: {
            borderRadius: theme.borderRadius.xs,
            fontSize: "12px",
            padding: "6px",
          },
        },
      ],
    }),
    sizeSmall: () => ({
      borderRadius: "12px",
      fontSize: "16px",
      padding: "8px",
    }),
    sizeMedium: ({ theme }) => ({
      borderRadius: theme.borderRadius.md,
      fontSize: "20px",
      padding: "10px",
    }),
    sizeLarge: ({ theme }) => ({
      borderRadius: theme.borderRadius.lg,
      fontSize: "20px",
      padding: "14px",
    }),
  },
};
